import './MainNavigation.css';
import React, { useEffect, useRef, useState } from 'react';
import { get, getDictionaryItem, getGlobalDictionaryTerm, isNavLinkRendered, NAV_LINKS, getIdFromName } from '../../utils';
import clsx from 'clsx';
import { styled } from 'linaria/lib/react';
import HeaderModuleWrapper from '../30_NavigationBar/HeaderModuleWrapper';
import RouterLink from '../atoms/RouterLink';
import IconNavclose from '../../components/atoms/Icons/IconNavclose';
import LazyPicture from '../atoms/LazyPicture';
import { canUseDOM } from '../../utils';
import { useLocation } from 'react-router-dom';
import { IconChevronRight, IconChevronLeft, IconToggleArrowDown } from '../../components/atoms/Icons';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { useStickyUp } from './useStickyUp';
import { useStickyDown } from './useStickyDown';
import { tealiumClickFunc, tealiumGenerateClickData, getLastPartInURL } from '../../utils/tealium';
import LoginBtn from '../30_NavigationBar/LoginBtn';
import { getListingCancelable } from '../../utils/getListing';
import { usePageZoom } from '../../utils/hooks/usePageZoom';
import useHasClass from '../../utils/hooks/useHasClass';
import { useMobileNav } from '../30_NavigationBar/useMobileNav';

/** Defines the props that are populated by data from CMS and application usage */

// NOTE: this class name is referenced in the AnchorNavigation component.
const mainNavCssClass = 'main-nav';
const commonTransition = '.3s linear';
const CLOSED_ITEM = -1;
const getHeaderHeight = () => {
  if (canUseDOM) {
    const header = document.querySelector('.dot-site-header');
    if (header) {
      return header.getBoundingClientRect().height;
    }
  }
  return 0;
};
const MainNavigation = _ref => {
  let {
    mainNavItems,
    primaryBrandLogoLink,
    primaryBrandLogo,
    secondaryBrandLogo,
    secondaryBrandLogoLink,
    logoWhiteImageLogo,
    accountLinks,
    menuLinks,
    dictionary,
    actions,
    mainMenuAnalytics,
    governmentLogoAnalytics,
    globalLinksAnalytics,
    languageSelector,
    globalLinks,
    isAnimate,
    venueShortlistVisible,
    setVenueShortlistVisible,
    venueShortlists,
    userProfile
  } = _ref;
  const isLargeNavigation = mainNavItems.length > 6;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const currentPageId = get(sitecoreContext, 'currentItemId');
  const plannerLabel = getGlobalDictionaryTerm(sitecoreContext, 'eventCalendarLabel') || 'Event calendar';
  const interactiveMapLabel = getGlobalDictionaryTerm(sitecoreContext, 'interactiveMapLabel') || 'Interactive map';
  const topPicksLabel = getGlobalDictionaryTerm(sitecoreContext, 'topPicksLabel') || 'Top picks';
  const searchLabel = getGlobalDictionaryTerm(sitecoreContext, 'topNavSearch') || 'Search';
  const venuesLabel = getGlobalDictionaryTerm(sitecoreContext, 'topNavTrip') || 'Venues';
  const submenuToggleLabel = getGlobalDictionaryTerm(sitecoreContext, 'toggleSubmenu') || 'toggle {name} submenu';
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const alternateUrls = get(sitecoreContext, 'alternateUrls', []);
  const languages = get(languageSelector, 'targetItem.children', []);
  const currentLang = get(sitecoreContext, 'language');
  const primaryBrandLogoLinkHref = get(primaryBrandLogoLink, 'url', `/${currentLang}`);
  const secondaryBrandLogoLinkHref = get(secondaryBrandLogoLink, 'url', '/');
  const indexVenues = get(sitecoreContext, 'configuration.indexValues.venues') || 'qa_venues_en';
  const menulinksArray = get(menuLinks, 'targetItem.links');
  const currentPath = get(languageSelector, 'currentPath', '');
  const isMobile = canUseDOM ? window.matchMedia(`(max-width: 991px)`).matches : false;
  const [filledMode, setFilledMode] = React.useState(false);
  const [buttonLanguageLabel, setButtonLanguageLabel] = useState('');
  const relatedSites = getDictionaryItem(dictionary && dictionary.dictionary, 'relatedSites') || 'Related sites';
  const [headerHeight, setHeaderHeight] = useState(getHeaderHeight);
  const [isMobileXS, setIsMobileXS] = React.useState(false);
  const locationURL = useLocation();
  const [isVdsite, setIsVdsite] = useState(false);
  const [showMobileMenuOnDesktop, setShowMobileMenuOnDesktop] = useState(false);
  const stickyUp = useStickyUp(50);
  const stickyDown = useStickyDown(100);
  // let initShortlistVenues = [];
  const {
    zoomLevel,
    zoomedDPR
  } = usePageZoom(400);
  const zoomLevel150 = usePageZoom(150);
  const zoomBreakPoint = zoomedDPR;
  const zoomBreakPointNav = zoomLevel150.zoomedDPR;
  const languageTiltle = get(languageSelector, 'targetItem.title.value');
  let initDisabledVenueShortlistTooltip = true;
  const linksArray = get(accountLinks, 'targetItem.links');
  const Login = linksArray && linksArray[2];
  const loginHref = get(Login, 'link.jss.value.href');
  const loginTitle = get(Login, 'title.jss.value');
  const z200Display = useHasClass('html', 'z200');
  const {
    mobileNavVisible,
    mobileNavActiveIndex,
    handleMobileNavToggleClick,
    handleMobileNavDropdownClick
  } = useMobileNav(isLargeNavigation, showMobileMenuOnDesktop);
  if (canUseDOM) {
    // initShortlistVenues = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');

    initDisabledVenueShortlistTooltip = !!localStorage.getItem('disabledVenueShortlistTooltip');
  }
  const [shortlistVenues, setShortlistVenues] = React.useState(false);
  const eventCalendar = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['eventCalendar']);
  const searchEnabled = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['search']);
  const interactiveMap = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['interactiveMap']);
  let hamburgerActiveClass = 'hamburger--active';
  const [openedDesktopItem, setOpenedDesktopItem] = useState(CLOSED_ITEM);
  const [isMenuFocused, setIsMenuFocused] = useState(false);
  const mobNavPanelValue = React.useRef(10);
  const navigationRef = useRef(null);
  useEffect(() => {
    const nav = navigationRef.current;
    const onFocusout = e => {
      if (!nav || !(e.relatedTarget instanceof Node) || !nav.contains(e.relatedTarget)) {
        setOpenedDesktopItem(CLOSED_ITEM);
      }
    };
    if (nav) {
      navigationRef.current.addEventListener('focusout', onFocusout);
    }
    return () => {
      nav && nav.removeEventListener("focusout", onFocusout);
    };
  }, []);
  useEffect(() => {
    if (!stickyUp) {
      setIsMenuFocused(false);
    }
  }, [stickyUp]);
  useEffect(() => {
    if (canUseDOM) {
      if (zoomLevel >= zoomBreakPointNav && window.screen.width < 2560) {
        setShowMobileMenuOnDesktop(true);
      } else if (z200Display) {
        setShowMobileMenuOnDesktop(true);
      } else {
        setShowMobileMenuOnDesktop(false);
      }
    }
  }, [zoomLevel, z200Display]);
  const corpNaviationCssVar = {
    '--active-item-color': isVdsite ? 'var(--main-color)' : '#00909a'
  };
  const addMarginTopForMainBlock = () => {
    if (canUseDOM) {
      const header = document.querySelector('.dot-site-header');
      const mainTag = document.querySelector('main.main.overflowXClip');
      if (!header || !mainTag || header.classList.contains('transparency-mode')) return;
      const headerHeightCurrent = header.getBoundingClientRect().height;
      setHeaderHeight(prev => prev !== headerHeightCurrent ? headerHeightCurrent : prev);
      mainTag.setAttribute('style', 'margin-top: ' + headerHeightCurrent + 'px');
    }
  };
  useEffect(() => {
    if (!canUseDOM) return;
    const observer = new MutationObserver(() => {
      const header = document.querySelector('.dot-site-header');
      const main = document.querySelector('main.main.overflowXClip');
      if (header && main) {
        addMarginTopForMainBlock();
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    window.addEventListener('resize', addMarginTopForMainBlock);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', addMarginTopForMainBlock);
    };
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      const header = document.querySelector('.dot-site-header');
      if (header) {
        if (stickyDown) {
          header.classList.add('filled');
          header.classList.add('filled');
        } else {
          header.classList.remove('filled');
        }
      }
    }
  }, [stickyDown]);
  useEffect(() => {
    if (canUseDOM) {
      const header = document.querySelector('.dot-site-header');
      if (header && !header.classList.contains('transparency-mode')) {
        setFilledMode(true);
      }
    }
  }, [locationURL]);
  useEffect(() => {
    if (canUseDOM) {
      if (document.body.classList.contains('vdsite')) {
        setIsVdsite(true);
      }
      const triggerUpdate = () => {
        const venues = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
        setShortlistVenues(!!venues.length);
      };
      triggerUpdate();
      document.body.addEventListener('shortlistVenues', triggerUpdate);
      return () => {
        document.body.removeEventListener('shortlistVenues', triggerUpdate);
      };
    }
  }, []);
  const getNewLanguage = () => {
    const activeLanguageCode = get(languageSelector, 'activeLanguage.languageCode');
    return languages.find(lang => get(lang, 'languageCode.value') !== activeLanguageCode);
  };
  useEffect(() => {
    const newLanguage = getNewLanguage();
    if (newLanguage) {
      setButtonLanguageLabel(get(newLanguage, 'languageName.value'));
    }
  }, [languageSelector]);
  const checkIsMobile = () => {
    const isMobile = canUseDOM && window.innerWidth <= 768;
    setIsMobileXS(isMobile);
    let hideTranslateY = 0;
    if (canUseDOM) {
      const alertBanner = document.querySelector('.alertBanner');
      const mainNav = document.querySelector('.corp-main-nav');
      if (mainNav) {
        const pseudo = window.getComputedStyle(mainNav, ':after');
        const content = pseudo.getPropertyValue('content');
        hideTranslateY += mainNav.offsetHeight;
        if (content !== 'none') {
          hideTranslateY += parseInt(window.getComputedStyle(mainNav, ':after').height || '0');
        }
        if (alertBanner && mainNav.className.includes('not-sticky')) {
          hideTranslateY += alertBanner.offsetHeight;
        }
      }
      if (mobNavPanelValue && mobNavPanelValue.current) {
        mobNavPanelValue.current = hideTranslateY;
      }
    }
  };
  const handleLanguageSwitch = () => {
    const newLanguage = getNewLanguage();
    if (newLanguage) {
      const langCode = get(newLanguage, 'languageCode.value');
      setButtonLanguageLabel(get(newLanguage, 'languageName.value'));
      var urlData = currentPath.split('/');
      if (urlData[0] === '' && urlData[1] === get(languageSelector, 'activeLanguage.languageCode')) {
        urlData.splice(1, 1);
      }
      var newPath = urlData.join('/');
      const langCodeAndPath = `/${langCode}/${newPath}`;
      const newUrl = langCodeAndPath.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
      if (canUseDOM) {
        window.location.href = window.location.origin + newUrl;
      }
    }
  };
  React.useEffect(() => {
    if (canUseDOM) {
      checkIsMobile();
      window.addEventListener('resize', checkIsMobile);
      const interval = setInterval(checkIsMobile, 1000);
      return () => {
        window.removeEventListener('resize', checkIsMobile);
        clearInterval(interval);
      };
    }
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      let ids = JSON.parse(localStorage.getItem('shortlistVenues') || '[]');
      if (ids.length) {
        var itemFilters = {
          filters: ids.map(id => `(objectID:${id})`).join(' OR '),
          facetFilters: [['type:Venue']],
          hitsPerPage: 100,
          page: 0
        };
        getListingCancelable(indexVenues, itemFilters, algoliaSettings).promise.then(response => {
          if (!response.hits.length) {
            setShortlistVenues(false);
          }
        });
      }
    }
  }, []);
  const checkIfElementActive = itemPageId => {
    if (!showMobileMenuOnDesktop) {
      if (currentPageId) {
        return itemPageId === currentPageId;
      }
    }
    return false;
  };
  const primaryLogos = () => {
    return get(primaryBrandLogo, 'jss.value.src') && /*#__PURE__*/
    //right logo
    React.createElement(RouterLink, {
      className: `brands__link ${!stickyDown ? 'inverted' : ''}`,
      href: primaryBrandLogoLinkHref,
      linktype: "external",
      openInSameTab: true,
      title: get(primaryBrandLogo, 'jss.value.alt'),
      ariaLabel: get(primaryBrandLogo, 'jss.value.alt'),
      onClick: () => {
        tealiumClickFunc(mainMenuAnalytics, 'Logo Govt. of Dubai');
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: "brand rs_skip dot-logo",
      alt: get(primaryBrandLogo, 'jss.value.alt'),
      "aria-hidden": "true",
      src: get(primaryBrandLogo, 'jss.value.src')
    }));
  };
  const secondaryLogos = () => {
    return get(secondaryBrandLogo, 'jss.value.src') && get(logoWhiteImageLogo, 'jss.value.src') && /*#__PURE__*/
    //left logo
    React.createElement(RouterLink, {
      className: `nav-brand-secondary  ${!stickyDown ? 'inverted' : ''}`,
      href: secondaryBrandLogoLinkHref,
      title: filledMode ? get(secondaryBrandLogo, 'jss.value.alt') : get(!stickyDown ? logoWhiteImageLogo : secondaryBrandLogo, 'jss.value.alt'),
      ariaLabel: get(!stickyDown ? logoWhiteImageLogo : secondaryBrandLogo, 'jss.value.alt'),
      onClick: () => {
        tealiumClickFunc(mainMenuAnalytics, 'DTCM Logo');
      }
    }, !isMobileXS ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      className: "brand rs_skip god-logo",
      id: "filled-mode-logo",
      alt: get(secondaryBrandLogo, 'jss.value.alt'),
      "aria-hidden": "true",
      src: get(secondaryBrandLogo, 'jss.value.src')
    }), /*#__PURE__*/React.createElement("img", {
      className: "brand rs_skip god-logo",
      id: "transparency-mode-logo",
      alt: get(!stickyDown ? logoWhiteImageLogo : secondaryBrandLogo, 'jss.value.alt'),
      "aria-hidden": "true",
      src: get(!stickyDown ? logoWhiteImageLogo : secondaryBrandLogo, 'jss.value.src')
    })) : /*#__PURE__*/React.createElement("img", {
      className: "brand rs_skip god-logo",
      alt: get(secondaryBrandLogo, 'jss.value.alt'),
      src: get(secondaryBrandLogo, 'jss.value.src')
    }));
  };
  const idModifier = isAnimate ? 'nav-helper' : 'nav-main';
  const checkIsLanguagesExists = () => {
    if (alternateUrls.length) {
      const alternateUrlsCodes = new Set(alternateUrls.map(lang => lang.lang));
      return languages.every(lang => alternateUrlsCodes.has(get(lang, 'languageCode.value')));
    }
    return null;
  };
  const actionButtonsBlockWithoutSearch = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledActionButton, {
    "aria-label": "Accessibility | AA+",
    className: "nav-btn  rs_skip corp-main-nav__action-btn round",
    onClick: () => {
      actions.onAccessibilitySettingsClicked();
      tealiumClickFunc(globalLinksAnalytics, `Accessibility Option`);
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "17",
    height: "21",
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    fill: `${stickyDown ? '##1A1A1A' : '#fff'}`,
    "clip-rule": "evenodd",
    d: "M7.75881 0.766998C7.7452 0.770332 7.67835 0.782 7.61027 0.792943C7.44703 0.819168 7.13765 0.913161 6.98997 0.98139C6.52719 1.19522 6.17345 1.64188 6.06773 2.14589C6.01458 2.39921 6.01727 2.51113 6.09317 3.20217C6.17129 3.91346 6.28187 4.20552 6.58766 4.50811C6.77989 4.69834 7.03425 4.81853 7.35375 4.87007C7.5075 4.89486 7.79154 4.88203 7.94036 4.84356C8.09621 4.80327 8.30933 4.69956 8.443 4.59895C8.57819 4.4972 8.80309 4.24525 8.93848 4.04389C9.13873 3.74607 9.31489 3.31491 9.39365 2.92985C9.42879 2.75805 9.43021 2.72384 9.42004 2.29307C9.41121 1.91803 9.40356 1.81531 9.37656 1.70978C9.28935 1.36878 9.06715 1.11092 8.70782 0.933692C8.46591 0.814398 8.30678 0.77629 8.01463 0.767724C7.88755 0.764011 7.77243 0.76368 7.75881 0.766998ZM6.7768 5.4567C6.50965 5.49398 6.25553 5.54975 5.94333 5.63957C5.45616 5.77974 4.83533 5.97073 4.55696 6.06607C3.69636 6.36086 2.77084 6.80625 2.29106 7.1565C2.18824 7.23158 2.09608 7.32399 1.92754 7.52098C0.868716 8.75866 0.161404 9.87233 0.0263487 10.5144C-0.0727436 10.9855 0.114333 11.3072 0.4754 11.2868C0.838133 11.2662 1.30458 10.8489 2.1973 9.74615C2.92485 8.84744 3.12232 8.61483 3.3604 8.37613C3.50362 8.23252 3.72359 8.05927 3.83851 7.99956C3.92585 7.95419 3.95422 7.94787 4.07009 7.94794C4.43315 7.94815 4.61902 8.21037 4.68354 8.81343C4.74143 9.35457 4.65668 9.97999 4.47411 10.3589L4.4095 10.4929L4.20678 10.6044C3.75206 10.8545 3.36305 11.1462 2.99686 11.512C2.71613 11.7923 2.54901 11.9916 2.3351 12.3009C2.13855 12.5852 2.01603 12.8243 1.88534 13.1787C1.54043 14.1141 1.36512 14.9728 1.39667 15.5722C1.46162 16.8058 1.85162 17.8459 2.60339 18.7906C2.80303 19.0414 3.01461 19.2557 3.34389 19.5406C3.65756 19.812 3.82891 19.9431 4.04328 20.0757C4.36766 20.2764 4.59776 20.3733 5.0791 20.512C5.73072 20.6997 6.14937 20.7642 6.71904 20.7647C7.15632 20.7651 7.35805 20.7458 7.79182 20.6621C8.54376 20.5171 9.29052 20.172 9.97708 19.6523C10.2146 19.4725 10.6453 19.049 10.859 18.7852C11.2184 18.3415 11.5361 17.7827 11.7284 17.2556C11.7788 17.1177 11.9446 16.7887 12.0471 16.6233C12.0893 16.555 12.0939 16.5524 12.1546 16.5618C12.2944 16.5834 12.4509 16.7136 12.507 16.855C12.6439 17.2003 12.9611 17.6027 13.1823 17.7116C13.3015 17.7703 13.4786 17.7904 13.6164 17.7609C13.9129 17.6973 14.369 17.4279 14.8662 17.0228C15.7537 16.2995 16.1267 15.8781 16.1549 15.5663C16.1666 15.4373 16.1403 15.3663 16.0499 15.283C15.9146 15.1582 15.7035 15.0853 15.4777 15.0853H15.3586L14.8555 15.3256C14.1108 15.6811 14.142 15.6686 14.0721 15.6394C13.9869 15.6038 13.9058 15.5084 13.8256 15.3494C13.7867 15.2722 13.3105 14.2733 12.7674 13.1296C11.7496 10.9859 11.6929 10.8759 11.5071 10.6821C11.3784 10.5479 11.1604 10.423 10.79 10.2713C10.5418 10.1696 9.9549 9.9767 9.54129 9.86086C8.91379 9.6851 8.22186 9.33685 7.93416 9.05196C7.77017 8.88958 7.70983 8.73392 7.7095 8.47238C7.7091 8.16589 7.77842 7.85756 7.9892 7.22825C8.1431 6.76876 8.17142 6.63453 8.17142 6.36441C8.17142 5.86624 7.98905 5.61194 7.54663 5.49317C7.44619 5.46621 7.35992 5.45833 7.12339 5.45454C6.96 5.45193 6.80404 5.45289 6.7768 5.4567ZM7.43698 11.0981C8.53706 11.274 9.48476 11.8267 10.1894 12.7033C10.7006 13.3393 11.0431 14.1878 11.1268 15.0254C11.1554 15.3117 11.1384 15.8957 11.0939 16.1581C11.0161 16.6159 10.8785 17.0425 10.679 17.4442C9.91143 18.9897 8.32914 19.9352 6.62826 19.8647C5.96112 19.8371 5.41133 19.6927 4.81278 19.3881C4.31296 19.1336 3.79156 18.7071 3.41882 18.2476C2.89288 17.5994 2.54703 16.7481 2.46 15.8875C2.43485 15.6388 2.4485 15.057 2.48502 14.8212C2.67462 13.5977 3.30673 12.5626 4.30115 11.8474C4.83386 11.4642 5.51927 11.1888 6.15817 11.101C6.26241 11.0867 6.36997 11.0719 6.3972 11.0681C6.52047 11.0511 7.27976 11.0729 7.43698 11.0981Z"
  }))), checkIsLanguagesExists() ? /*#__PURE__*/React.createElement(StyledActionButton, {
    "aria-label": "language",
    className: `lang-btn ${isVdsite ? 'nav-btn' : ''} header-tr__link header-tr__link-lang
          rs_skip corp-main-nav__action-btn`,
    onClick: () => {
      handleLanguageSwitch();
      tealiumClickFunc(globalLinksAnalytics, `Language Switch`);
    }
  }, buttonLanguageLabel) : null, isVdsite && loginHref && !isMobileXS ? /*#__PURE__*/React.createElement(StyledActionButton, {
    className: "login-btn header-tr__link header-tr__link-lang  rs_skip corp-main-nav__action-btn"
  }, /*#__PURE__*/React.createElement(LoginBtn, {
    userProfile: userProfile,
    isMobileView: true,
    accountLinks: accountLinks,
    dictionary: dictionary,
    closeNav: handleMobileNavToggleClick,
    analyticsClick: () => tealiumClickFunc(globalLinksAnalytics, `Login`)
  })) : '');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: ` ${mainNavCssClass}${mobileNavVisible ? ' mobile-nav-visible' : ''} corp-main-nav
				${!stickyDown ? 'not-sticky' : 'sticky'}
				${filledMode && !stickyDown ? 'filled-mode' : ''}
				`,
    isAnimate: isAnimate,
    venueShortlistVisible: venueShortlistVisible,
    showMobileMenuOnDesktop: showMobileMenuOnDesktop
  }, /*#__PURE__*/React.createElement("div", {
    className: `row main-navigation-block brand-site
				${stickyUp || isMenuFocused ? ' stickyUp' : ''} ${stickyDown ? ' stickyDown' : ''}
				${mobileNavVisible ? ' mobile-nav-visible' : ''}
				`
  }, /*#__PURE__*/React.createElement("div", {
    className: 'brand-site__logo'
  }, rtl ? primaryLogos() : secondaryLogos(), rtl ? secondaryLogos() : primaryLogos())), /*#__PURE__*/React.createElement("div", {
    style: corpNaviationCssVar,
    className: `corp-main-nav__mob-controls
					${mobileNavVisible ? 'with-mob-menu' : ''}
					${stickyUp || isMenuFocused ? ' stickyUp' : ''} ${stickyDown ? ' stickyDown' : ''}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-close-btn",
    onClick: handleMobileNavToggleClick
  }, /*#__PURE__*/React.createElement(IconNavclose, null)), /*#__PURE__*/React.createElement("div", {
    className: "hamburger-wrapper d-print-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: `hamburger${mobileNavVisible ? ` ${hamburgerActiveClass}` : ''}`,
    onClick: () => {
      handleMobileNavToggleClick();
      tealiumClickFunc(mainMenuAnalytics, 'Mobile Top Navigation');
    },
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hamburger__spike"
  }, " "))), /*#__PURE__*/React.createElement("div", {
    className: `corp-main-nav__animated-block`
  }, /*#__PURE__*/React.createElement("div", {
    className: `col col-lg position-static corp-main-nav__mob-menu-wrapper	${mobileNavVisible ? ' mobile-nav-visible' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-wrapper",
    style: {
      top: `${isMobileXS ? mobNavPanelValue.current : 0}px`,
      height: `calc(100vh - ${Math.abs(isMobileXS ? mobNavPanelValue.current : 0)}px)`
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-close-btn tablet-only",
    onClick: handleMobileNavToggleClick
  }, /*#__PURE__*/React.createElement(IconNavclose, null)), /*#__PURE__*/React.createElement("ul", {
    ref: navigationRef,
    className: "navigation"
  }, mainNavItems.map((item, itemIndex) => {
    const targetItem = get(item, 'featuredItem.targetItem', {});
    const fallbackHeaderImage = get(targetItem, 'fallbackImage') || get(targetItem, 'headerImage');
    const urlTargetItem = get(targetItem, 'url', '');
    const featuredTitle = get(targetItem, 'title.jss.value') || get(targetItem, 'pageTitle.jss.value', '');
    const hasChildrenToShow = item.children && item.children.filter(el => {
      const label = el.label && el.label.value;
      const description = el.description && el.description.value;
      return label || description;
    });
    const idForDropdown = item.name ? `subnav-dropdown-${getIdFromName(item.name)}` : '';
    const children = hasChildrenToShow.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "drop-down-wrapper",
      "data-cy": "navigation-dropdown",
      id: idForDropdown
    }, /*#__PURE__*/React.createElement("ul", {
      className: "drop-down-menu"
    }, /*#__PURE__*/React.createElement("li", {
      className: "drop-down-menu__col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "nav-grid nav-grid--four"
    }, item.children.map((child, childIndex) => {
      if (!child.label.value || child.label.value === '$name') {
        return null;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: `${isAnimate ? 'animate-nav-' : 'static-nav-'}${childIndex}-${childIndex}`
      }, get(child, 'link.url') && get(child, 'label.value') ? /*#__PURE__*/React.createElement("div", {
        className: "nav-grid__list",
        key: childIndex
      }, /*#__PURE__*/React.createElement(RouterLink, {
        className: "link-chevron",
        href: get(child, 'link.url'),
        onClick: () => {
          tealiumClickFunc(governmentLogoAnalytics, [getLastPartInURL(item.link.url), getLastPartInURL(child.link.url)]);
          handleMobileNavToggleClick();
        },
        dataCy: "navigation-link-chevron",
        linktype: "external",
        ariaLabel: get(child, 'label.value'),
        openInSameTab: true
      }, child.label.value), rtl ? /*#__PURE__*/React.createElement(IconChevronLeft, {
        className: "icon-chevron-right rs_skip"
      }) : /*#__PURE__*/React.createElement(IconChevronRight, {
        className: "icon-chevron-right rs_skip"
      }), child.description && child.description.value ? /*#__PURE__*/React.createElement("p", {
        className: "dd-para"
      }, child.description.value) : null) : null);
    }))), targetItem.url && featuredTitle ? /*#__PURE__*/React.createElement("li", {
      className: "drop-down-menu__col drop-down-menu__col--banner d-none d-lg-block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "dd-img-placeholder"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      href: urlTargetItem,
      "aria-label": targetItem.name,
      onClick: () => {
        tealiumClickFunc(mainMenuAnalytics, `Banner Click : ${targetItem && targetItem.name}`);
      },
      title: get(fallbackHeaderImage, 'jss.value.alt', ''),
      linktype: "external",
      openInSameTab: true
    }, fallbackHeaderImage && get(fallbackHeaderImage, 'jss.value.src', '').length && /*#__PURE__*/React.createElement(LazyPicture, {
      className: "dd-img-placeholder-inner",
      useEmptyPlaceholder: true
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 991px)",
      srcSet: `${get(fallbackHeaderImage, 'jss.value.src', '')}&cw=216&ch=160`
    }), /*#__PURE__*/React.createElement("img", {
      className: "rs_skip",
      src: `${get(fallbackHeaderImage, 'jss.value.src', '')}&cw=216&ch=160`,
      alt: get(fallbackHeaderImage, 'jss.value.alt', '')
    })))), /*#__PURE__*/React.createElement(RouterLink, {
      className: "dd-link drop-down-menu__col-featured-link",
      href: urlTargetItem,
      title: featuredTitle,
      "aria-label": featuredTitle,
      onClick: () => {
        tealiumClickFunc(mainMenuAnalytics, `Title Click : ${targetItem && targetItem.name}`);
      },
      linktype: "external",
      openInSameTab: true
    }, featuredTitle)) : null)) : null;
    if (!item.label.value || item.label.value === '$name') {
      return null;
    }
    const itemExpanded = isMobile ? mobileNavActiveIndex === itemIndex : openedDesktopItem === itemIndex;
    return /*#__PURE__*/React.createElement("li", {
      className: clsx('navigation__list', {
        'has-drop-down': children,
        'navigation__list--active': mobileNavActiveIndex === itemIndex,
        'navigation__list--hover': !showMobileMenuOnDesktop && openedDesktopItem === itemIndex,
        'sticky': stickyDown,
        'active-page-item': checkIfElementActive(get(item, 'link.targetItem.id') || '')
      }),
      key: `${isAnimate ? 'animate-nav-' : 'static-nav-'}${itemIndex}`,
      onMouseEnter: () => !showMobileMenuOnDesktop && setOpenedDesktopItem(itemIndex),
      onMouseLeave: () => !showMobileMenuOnDesktop && setOpenedDesktopItem(CLOSED_ITEM)
    }, /*#__PURE__*/React.createElement(RouterLink, {
      onClick: () => {
        tealiumClickFunc(mainMenuAnalytics, getLastPartInURL(item.link.url));
        handleMobileNavToggleClick();
      },
      onFocus: () => setIsMenuFocused(true),
      className: "nav-link",
      href: get(item, 'link.url'),
      dataCy: "navigation-link",
      linktype: "external",
      openInSameTab: true
    }, item.label.value), children ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: "nav-link__arrow nav-link__arrow-btn desktop-only",
      onKeyDown: e => {
        if ((e.which === 13 || e.which === 32) && !showMobileMenuOnDesktop) {
          e.preventDefault();
          setOpenedDesktopItem(openedDesktopItem === itemIndex ? CLOSED_ITEM : itemIndex);
        }
      },
      "aria-expanded": itemExpanded,
      "aria-label": submenuToggleLabel.replace('{name}', item.label.value),
      "aria-controls": idForDropdown
    }, /*#__PURE__*/React.createElement(IconToggleArrowDown, null)), /*#__PURE__*/React.createElement("button", {
      className: "nav-link__arrow mobile-only",
      onClick: () => {
        tealiumClickFunc(mainMenuAnalytics, getLastPartInURL(item.link.url));
        handleMobileNavDropdownClick(itemIndex);
      },
      "aria-expanded": itemExpanded,
      "aria-label": submenuToggleLabel.replace('{name}', item.label.value),
      "aria-controls": idForDropdown
    }, /*#__PURE__*/React.createElement(IconToggleArrowDown, null))) : null, children);
  })), /*#__PURE__*/React.createElement("div", {
    className: " d-lg-none related-sites rs_skip"
  }, get(globalLinks, 'targetItem.children', []).length ? /*#__PURE__*/React.createElement("div", {
    className: "nav-external"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h6 nav-external__heading"
  }, relatedSites), get(globalLinks, 'targetItem.children', []).map((globalLink, index) => {
    const target = get(globalLink, 'link.target', '') === '' ? '_self' : globalLink.link.target;
    const rel = target === '_blank' ? 'noopener noreferrer' : undefined;
    const linkLabel = get(globalLink, 'label.value');
    const title = target === '_blank' ? `${linkLabel} | ${newWindowLabel}` : linkLabel;
    return /*#__PURE__*/React.createElement("a", {
      className: "nav-external__link",
      href: get(globalLink, 'link.url'),
      target: target,
      rel: rel,
      key: `top-nav-mobile-link-${index}`,
      onClick: () => tealiumClickFunc(globalLinksAnalytics, linkLabel),
      title: title
    }, linkLabel);
  })) : null), isMobileXS ? /*#__PURE__*/React.createElement("div", {
    className: `nav-wrapper__actions ${zoomLevel >= zoomBreakPoint ? 'zoomed' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-wrapper__actions-top"
  }, " ", actionButtonsBlockWithoutSearch), secondaryLogos()) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("div", {
    className: "rs_skip"
  }, /*#__PURE__*/React.createElement(LoginBtn, {
    userProfile: userProfile,
    isMobileView: true,
    accountLinks: accountLinks,
    dictionary: dictionary,
    closeNav: handleMobileNavToggleClick,
    analyticsClick: () => tealiumClickFunc(globalLinksAnalytics, `Login`)
  })), languageTiltle && /*#__PURE__*/React.createElement("div", {
    className: "navigation__list mob-lang rs_skip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lang-selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "lang-selector__label",
    htmlFor: `dd-lang-selector-${idModifier}`
  }, languageTiltle), /*#__PURE__*/React.createElement("select", {
    className: "lang-selector__dd",
    id: `dd-lang-selector-${idModifier}`,
    onChange: e => {
      if (canUseDOM) {
        const [, cValue] = window.location.pathname.split('/');
        const nValue = e.currentTarget.selectedOptions[0].value;
        window.location.href = window.location.origin + window.location.pathname.replace(`/${cValue}/`, nValue);
      }
      tealiumClickFunc(globalLinksAnalytics, `Language Switch`);
    }
  }, get(languageSelector, 'targetItem.children', []).map((lang, index) => {
    const langCode = get(lang, 'languageCode.value');
    const langPath = get(languageSelector, 'currentPath');
    // const langPath = `/en/things-to-do`;
    var urlData = langPath.split('/');
    urlData.splice(0, 2).join('/');
    var newPath = urlData.join('/');
    const langCodeAndPath = `/${langCode}/${newPath}`;
    const currentLanguagePath = langCodeAndPath.replace(/(https?:\/\/)|(\/)+/g, '$1$2');
    if (alternateUrls && alternateUrls.some(obj => obj.lang === get(lang, 'languageCode.value'))) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        selected: get(languageSelector, 'activeLanguage.languageCode') === get(lang, 'languageCode.value'),
        value: `${currentLanguagePath}`
      }, get(lang, 'languageName.value'));
    } else if (!alternateUrls) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        selected: get(languageSelector, 'activeLanguage.languageCode') === get(lang, 'languageCode.value'),
        value: `${currentLanguagePath}`
      }, get(lang, 'languageName.value'));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  })))))), isMobileXS && /*#__PURE__*/React.createElement("div", {
    className: 'brand-site__logo'
  }, primaryLogos()), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "nav-btns-cnt",
    "data-cy": "navigation-search-button"
  }, get(searchEnabled, 'isSearch.jss.value') && /*#__PURE__*/React.createElement(StyledActionButton, {
    "aria-label": searchLabel,
    className: "nav-btn search-box__link corp-main-nav__action-btn",
    onClick: () => {
      tealiumClickFunc(tealiumGenerateClickData(mainMenuAnalytics, 'Site Search'));
      actions.onSearchClicked();
    }
  }, /*#__PURE__*/React.createElement("svg", {
    className: "search-icon",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13 11H12.21L11.93 10.73C13.13 9.33002 13.75 7.42001 13.41 5.39002C12.94 2.61002 10.62 0.390015 7.82002 0.0500152C3.59002 -0.469985 0.0300153 3.09002 0.550015 7.32002C0.890015 10.12 3.11002 12.44 5.89002 12.91C7.92001 13.25 9.83002 12.63 11.23 11.43L11.5 11.71V12.5L15.75 16.75C16.16 17.16 16.83 17.16 17.24 16.75C17.65 16.34 17.65 15.67 17.24 15.26L13 11ZM7.00002 11C4.51002 11 2.50002 8.99002 2.50002 6.50002C2.50002 4.01002 4.51002 2.00002 7.00002 2.00002C9.49002 2.00002 11.5 4.01002 11.5 6.50002C11.5 8.99002 9.49002 11 7.00002 11Z",
    fill: `${stickyDown ? '##1A1A1A' : '#fff'}`
  })), !isMobileXS && /*#__PURE__*/React.createElement("span", null, searchLabel, "...")), !isMobileXS && actionButtonsBlockWithoutSearch))))));
};
export default MainNavigation;
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className,
    isAnimate,
    venueShortlistVisible,
    showMobileMenuOnDesktop
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `navHolder ${showMobileMenuOnDesktop ? 'corp-main-nav-overflowed' : ''} ${rtl ? 'rtl' : ''}`,
    style: {
      position: 'relative',
      zIndex: venueShortlistVisible ? 23 : isAnimate || showMobileMenuOnDesktop ? 21 : 9
    }
  }, /*#__PURE__*/React.createElement(HeaderModuleWrapper, {
    className: `${commonStyles} ${transparentNavigationStyle} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children));
};
const StyledActionButton = /*#__PURE__*/styled("button")({
  name: "StyledActionButton",
  class: "s1eqpx9u"
});
const commonStyles = "c1aj49sd";
const ltrStyles = "lya1hnf";
const rtlStyles = "r44av9n";
const transparentNavigationStyle = "t1apquax";